import { createSelector } from 'reselect';
import { getDocumentsById } from 'documents/store/documents/selectors';
import { getFoldersById } from 'documents/store/folders/selectors';

export const getFavoriteIds = state => state.favorites.ids;

export const getFavoritesIsLoading = state => state.favorites.isLoading;

export const getFavorites = createSelector(
  [getDocumentsById, getFoldersById, getFavoriteIds],
  (documents, folders, ids) => ids.map(id => documents[id] || folders[id]) || [],
);
